import Dexie from "dexie";

const db = new Dexie("Admin");
db.version(0.1).stores({
  options: `++key, value`
});

export default {
  async getToken() {
    const option = await db.options.get("token");
    // console.log("db.getToken", option);
    if (option) return option.value;
    else return false;
  },
  async saveToken(token) {
    // console.log("db.saveToken", token);
    await db.transaction("rw", db.options, async () => {
      await db.options.put({ key: "token", value: token });
    });
  },
  async deleteToken() {
    // console.log("db.deleteToken");
    await db.transaction("rw", db.options, async () => {
      await db.options.delete("token");
    });
  },
  async saveUser(display_name, display_image, role) {
    // console.log("db.saveUser", display_name, display_image, role);
    await db.transaction("rw", db.options, async () => {
      let data = [];
      data.push({ key: "display_name", value: display_name });
      data.push({ key: "display_image", value: display_image });
      data.push({ key: "role", value: role });
      await db.options.bulkPut(data).then(() => {});
    });
  },
  async getUser() {
    const data = db.options
      .where("key")
      .anyOf("display_name", "display_image", "role");
    let result = {};
    await data.each(e => (result[e.key] = e.value));
    // console.log("db.getUser", result);
    return result;
  },
  async saveLocale(lang) {
    await db.transaction("rw", db.options, async () => {
      await db.options.put({ key: "lang", value: lang });
    });
  },
  async getLocale() {
    const option = await db.options.get("lang");
    if (option) return option.value;
    else return false;
  }
};
